import { Component } from '@angular/core';

@Component({
    selector: 'app-offline',
    templateUrl: './app.offline.component.html',
    standalone: false
})
export class AppOfflineComponent {
  /** Recarrega o app: navegar para `/` reaproveitaria o estado offline e voltaria para cá. */
  voltarParaOSistema() {
    window.location.assign('/');
  }
}
